import { createContext, useContext } from 'react'

import type {
  Channel,
  ChannelMixin,
  Consumer,
  Subscription,
} from '@/services/lukita/websocket'

export interface WebsocketContextProps {
  isReady: boolean
  consumer: Consumer | null
  subscribe: (
    channel: Channel,
    mixin: Partial<ChannelMixin>,
  ) => Subscription | undefined
  unsubscribe: (subscription?: Subscription) => void
}

export const WebsocketContext = createContext<WebsocketContextProps | null>(
  null,
)

export const useWebsocketContext = () => {
  const context = useContext(WebsocketContext)
  if (!context) {
    throw new Error('useWebsocketContext must be used within WebsocketProvider')
  }
  return context
}
